import { SkeletonGroupProps } from '@shared/components/Skeleton';
import { Box, styled, StyleSystemProps } from '@withjoy/joykit';
import { REFINEMENT_PANEL_STICKY_THRESHOLD_CSS_VAR } from '../../Catalog.constants';

export const StyleFacetListContainer = styled(Box)``;

const facetListContainerStyles: StyleSystemProps = {
  padding: 5,
  width: 304,
};

const dividerStyles: StyleSystemProps = {
  _notLastChild: {
    marginY: 1,
  },
  _last: {
    display: 'none',
  },
};

const filterScrollableContainerStyles: StyleSystemProps = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  maxHeight: { md: 'calc(100vh - 64px)' },
  position: { md: 'sticky' },
};

export const styles = {
  listContainer: facetListContainerStyles,
  filtersScrollableContainer: filterScrollableContainerStyles,
  divider: dividerStyles,
};

export const REFINEMENT_FACET_LIST_SKELETON_OVERRIDES: SkeletonGroupProps['overrides'] = {
  Root: {
    props: {
      top: {
        md: `var(${REFINEMENT_PANEL_STICKY_THRESHOLD_CSS_VAR}, 56px)`,
      },
    },
  },
};
